import Search from "../entities/Search";
import { SettingsRepository } from "../repositories/SettingsRepository";

export class GetPlaces {
	constructor(private repository: SettingsRepository) {}

	execute(params: GetPlacesParams): Promise<Search[]> {
		return this.repository.getPlaces(params.search );
	}
}

export class GetPlacesParams {
	constructor(public search : string) {}
}
